export const externalLinks = {
  privacyPolicy: 'https://quick.aero/privacy-policy/',
  contact: 'https://quick.aero/contact-us/',
  about: 'https://quick.aero/leading-technology/',
  helpDesk: 'https://quick.atlassian.net/servicedesk/customer/portal/3',
  conditionsOfCarriage: 'https://quick.aero/qonline-conditions-of-carriage/',
  trackSearch:
    'https://www.quickonline.com/cgi-bin/WebObjects/BOLSearch.woa/wa/',
};
